import layouts from 'layouts';

const initialState = {
  ...layouts,
};

const reducer = (state = initialState) => state;

export default reducer;
